import axios from 'axios';

// Configura la URL base si es necesario
axios.defaults.baseURL = 'https://api3.argoth.com.mx';
//axios.defaults.baseURL = 'http://localhost:3001';

axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

export default axios; 